import { App } from './App'

export { getServerSideProps } from './data-fetching/getServerSideProps'

export { App }
export default App
